import { create } from 'zustand';
import { GameSystem } from '../types';

const STORAGE_KEY = 'frostgrave:ui:game-system';

const readStoredGameSystem = (): GameSystem =>
  localStorage.getItem(STORAGE_KEY) === 'stargrave' ? 'stargrave' : 'frostgrave';

interface GameStore {
  activeGameSystem: GameSystem;
  setActiveGameSystem: (gameSystem: GameSystem) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  activeGameSystem: readStoredGameSystem(),
  setActiveGameSystem: (gameSystem) => {
    localStorage.setItem(STORAGE_KEY, gameSystem);
    set({ activeGameSystem: gameSystem });
  },
}));